import { 
    PRODUCT_FAIL, PRODUCT_REQUEST, PRODUCT_SUCCESS
  } from '../constants/productConstants'

const initialState = {
    validation: [],
    error: []
}

export const productReducer = (state = initialState, action) => {
switch (action.type) {
    case PRODUCT_REQUEST:
    return { ...state, loading: true, error: [], validation: [] }
    case PRODUCT_SUCCESS:
    return { ...state,loading: false, listsProduct: action.payload }
    case PRODUCT_FAIL:
    return { ...state, loading: false, error: action.payload }
    default:
    return state
}
}